"use client";

import type { SupTransactionType, SupWeb3TxSingleVault } from "@/types";
import React, { useMemo } from "react";

import Web3CommonVaultMultiStep from "@/components/Web3/Common/Vault/MultiStep";
import { SupText, SupTracker } from "@repo/core-ui";
import Link from "next/link";
import { SupLinkExternal } from "@repo/core-ui";

interface Web3CommonVaultChecksProps {
  singleVault: SupWeb3TxSingleVault;
  type: SupTransactionType;
}

export default function Web3CommonVaultChecks({ singleVault, type }: Web3CommonVaultChecksProps) {
  const isAvailable = useMemo(() => {
    return singleVault.form_implementation_id !== 1 ? (singleVault.underlying_wrapper_vaults?.length ?? 0) > 0 : !!singleVault.superform_address;
  }, [singleVault.form_implementation_id, singleVault.superform_address, singleVault.underlying_wrapper_vaults?.length]);

  return (
    <div className="inline-flex w-full flex-col items-center justify-start gap-6 py-4">
      {singleVault.recommend_vault_share_withdrawal && <Web3CommonVaultMultiStep type={type} />}
      <div className="flex h-11 flex-col items-start justify-start gap-1 self-stretch px-2">
        <div className="inline-flex h-5 items-center justify-start self-stretch">
          <SupText family="mono" variant="caption">
            vault status
          </SupText>
        </div>
        {isAvailable ? <SupTracker variant="success">VAULT AVAILABLE</SupTracker> : <SupTracker variant="warning">Has no superform address set</SupTracker>}
      </div>
      <div className="flex flex-col items-start justify-start gap-1 self-stretch px-2">
        <div className="inline-flex h-5 items-center justify-start self-stretch">
          <SupText family="mono" variant="caption">
            Vault details
          </SupText>
        </div>
        <Link
          className="inline-flex min-w-[140px] max-w-full cursor-pointer items-center space-x-2 whitespace-pre-wrap font-mono font-normal uppercase leading-6 text-neutral-800 underline decoration-from-font underline-offset-2 hover:text-neutral-900"
          href={`/vault/${singleVault.id}/`}
        >
          Visit vault page
          <SupLinkExternal className="ml-2" />
        </Link>
        {singleVault.protocol && (
          <Link
            className="inline-flex min-w-[140px] max-w-full cursor-pointer items-center space-x-2 whitespace-pre-wrap font-mono font-normal uppercase leading-6 text-neutral-800 underline decoration-from-font underline-offset-2 hover:text-neutral-900"
            href={`/protocol/${singleVault.protocol.id}/`}
          >
            Visit protocol page
            <SupLinkExternal className="ml-2" />
          </Link>
        )}
      </div>
    </div>
  );
}
